module.exports = __webpack_public_path__ + "static/dangercrew-steampage-video-49319ce8bd91fdce652a61c1da94a7a4.mp4";